/* tslint:disable */
/* eslint-disable */

/**
 * 0 = NotRequired
 * 
 * 1 = Pending
 * 
 * 2 = Pass
 * 
 * 3 = Fail
 * 
 * 4 = Hold
 */
export enum PartReceiptQaStatus {
  NotRequired = 0,
  Pending = 1,
  Pass = 2,
  Fail = 3,
  Hold = 4
}
